import {axios} from '@js/utilities/axios.js';
export default {
	namespaced: true,
	state: {
		cancelToken: null,
	},
	actions: {
		fetchCompanies(context, params) {
			if (context.state.cancelToken) {
				context.state.cancelToken.cancel();
			}

			const CancelToken = axios.CancelToken;
			context.commit('setCancelToken', CancelToken.source());

			return axios.get('/api/companies', {
				params: params,
				cancelToken: context.state.cancelToken.token,
			});
		}
	},
	mutations: {
		setCancelToken(state, cancelToken) {
			state.cancelToken = cancelToken;
		}
	},
	getters: {}
}
